'use strict';
const angular = require('angular');

const uiRouter = require('angular-ui-router');

import routes from './guidance.routes';

export class GuidanceComponent {
  /*@ngInject*/
  constructor() {
    this.message = 'Hello';
  }
}

export default angular.module('websiteApp.guidance', [uiRouter])
  .config(routes)
  .component('guidance', {
    template: require('./guidance.html'),
    controller: GuidanceComponent,
    controllerAs: 'guidanceCtrl'
  })
  .name;



// WEBPACK FOOTER //
// ./client/app/account/housing/guidance/guidance.component.js